module.exports = __webpack_public_path__ + "static/media/moraine-46.822b8a6c.jpg";